import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.jsx';

export default class Input extends Component {
    static propTypes = {
        id: PropTypes.string,
        maxCount: PropTypes.number,
        onInput: PropTypes.func,
        onSelect: PropTypes.func,
        optionsToExclude: PropTypes.any.isRequired,
        placeholder: PropTypes.string,
        repeatOptions: PropTypes.bool
    };

    static defaultProps = {
        id: '',
        maxCount: 5,
        onInput: null,
        onSelect: null,
        placeholder: '',
        repeatOptions: false
    };

    constructor(props) {
        super(props);
        this.id = this.props.id;
        this.state = {activeState: false, options: []};
        this.handleInput = this.handleInput.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }


    shouldComponentUpdate() {
        return true;
    }

    getUnselected(inputArray, alreadySelected) {
        let input = new Set(inputArray);
        let selected = new Set(alreadySelected);
        return Array.from(new Set(
            [...input].filter(x => !selected.has(x)))).slice(0, this.props.maxCount);
    }


    handleInput() {
        if (this.inputRef.value === '') {
            this.setState({activeState: false});
        } else {
            this.setState({activeState: true});
            //if we typed or selected the option, we should clear the autocomplete and change the icon on it
            if (this.state.options.includes(this.inputRef.value)) {
                let selected = this.inputRef.value;
                this.inputRef.value = '';
                this.setState({activeState: false});
                if (this.props.onSelect) {
                    this.props.onSelect(selected);
                }
            } else {
                //if we are keeping on typing, we will have new options in the datalist
                if (this.props.onInput) {
                    this.props.onInput(this.inputRef.value).then((inputArray) => {
                        if (this.props.repeatOptions) {
                            this.setState({options: inputArray.slice(0, this.props.maxCount)});
                        } else {
                            this.setState({options: this.getUnselected(inputArray, this.props.optionsToExclude)});
                        }
                    });
                }
            }
        }
    }

    handleDeleteClick() {
        this.inputRef.value = '';
        this.setState({activeState: false});
    }

    render() {
        return (
            <div className="autocomplete">
                <input
                    className="autocomplete__input"
                    list={'autocompleteOptions' + this.id}
                    onChange={this.handleInput}
                    placeholder={this.props.placeholder}
                    ref={el => this.inputRef = el}
                    type="text"
                />
                {this.state.activeState ?
                    <span onClick={this.handleDeleteClick}>
                        <Icon
                            className="autocomplete__icon_delete"
                            name="delete"
                        />
                    </span> :
                    <Icon
                        className="autocomplete__icon_search"
                        name="search"
                    />}
                <datalist
                    className="autocomplete__options"
                    id={'autocompleteOptions' + this.id}
                >
                    {this.state.options.map((option) => (
                        <option
                            key={option}
                            value={option}
                        />
                    ))}
                </datalist>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Input.jsx